import { ReactComponent } from "./ic_help.svg";

interface Props {
  fill?: string;
  className?: string;
  width?: string;
  height?: string;
}

const HelpIcon: React.FC<Props> = (Props) => <ReactComponent {...Props} />;

export default HelpIcon;
